// extracted by mini-css-extract-plugin
export default {"card":"VehicleCard-module__card--pfn8c","smallBar":"VehicleCard-module__smallBar--7NRnI"};